<script>
export default {
  props: {
    icon: {
      type: Boolean, // true/false
      required: false,
      default: false,
    },
    size: {
      type: String, // small:32 / medium:48 / large:56
      required: false,
      default: 'small',
    },
    type: {
      type: String, // light / blue / warning
      required: false,
      default: 'light',
    },
    heading: {
      type: String,
      default: '',
      required: false,
    },
    contentPosition: {
      default: 'light', // start / center / end
      type: String,
      required: false,
    },
    close: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  methods: {
    closeNotification() {
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
  },
};
</script>

<template>
  <div class="notification-wrapper">
    <h6 class="notification-title" v-if="heading">{{ heading }}</h6>
    <div
      class="notification"
      :class="`notification-${type} notification-size-${size}`"
    >
      <div class="row fill-available" :class="`align-items-${contentPosition}`">
        <div class="col-auto align-self-start pr-0" v-if="icon">
          <slot name="icon"></slot>
        </div>
        <div class="col">
          <slot />
        </div>
        <div
          class="col-auto notification-close"
          v-if="close"
          @click="closeNotification"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="25.414" height="25.415" viewBox="0 0 25.414 25.415" v-bind:class="'icon icon-close'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" stroke="#fff" stroke-width="2"><path data-name="Path 3" d="M.707.707l24 24"/><path data-name="Path 4" d="M24.707.707l-24 24"/></g></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.notification {
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  padding: 10px 8px;
  h5 {
    margin-bottom: 5 !important;
  }
  a {
    font-size: 14px !important;
    font-weight: normal !important;
    text-decoration: underline !important;
  }
  .content {
    font-weight: lighter !important;
    margin-bottom: 20px;
  }
  svg {
    height: 28px;
    margin-bottom: 5px;
    margin-top: 5px;
    width: 28px;
  }
  .notification-close {
    cursor: pointer;
    svg {
      height: 12px;
      width: 12px;
    }
  }
  &.notification-warning {
    h1,
    h2,
    h3,
    h4,
    h5,
    p,
    a {
      color: $color-white;
    }
    svg {
      fill: $color-white;
    }
  }
  &.notification-blue {
    h1,
    h2,
    h3,
    h4,
    h5,
    div,
    a {
      color: $color-white;
    }
    svg {
      fill: $color-white;
    }
  }
  &.notification-size-large {
    padding: 6px 30px 6px 12px;
    .content {
      font-size: 14px;
    }
    svg {
      height: 56px;
      width: 56px;
    }
    .notification-close {
      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
  .fill-available {
    width: 100%;
    width: -moz-available;
    width: -webkit-fill-available;
  }
}
.notification-light {
  background-color: $color-off-white-one;
}
.notification-blue {
  background-color: $color-primary;
  color: $color-white;
}
.notification-warning {
  background-color: $color-orange;
  color: $color-white;
}
h6.notification-title {
  color: $color-dark-gray;
  font-size: 10px;
  font-weight: 900;
  margin-bottom: 10px;
}
</style>
